<template>
    <div class="px-4 py-3 space-y-6">
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 py-4 mb-6">
      <h1 class="text-xl font-semibold text-gray-800">Marketing</h1>
          <!-- Actions -->
    <div class="flex flex-row sm:items-center sm:space-x-2">
      <button class="flex items-center gap-2 bg-black text-white text-sm font-semibold rounded-md px-4 py-2 shadow-md hover:shadow-lg transition-shadow">
        <i class="fas fa-user-plus"></i>
        Ajouter des Leads
      </button>
      <button class="flex items-center gap-2 border border-gray-300 text-sm font-semibold rounded-md px-4 py-2 mt-2 sm:mt-0 hover:bg-gray-100">
        <i class="fas fa-sliders-h"></i>
        Filtrer
      </button>
      <button class="flex items-center gap-2 border border-gray-300 text-sm font-semibold rounded-md px-4 py-2 mt-2 sm:mt-0 hover:bg-gray-100">
       
        Liste : BookmySalon
      </button>
    </div>
    </div>

    

    <!-- Cards Marketing -->
    <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
      <!-- Card: Total de prospects -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Total de prospects</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M12 12c2.485 0 4.5-2.015 4.5-4.5S14.485 3 12 3 7.5 5.015 7.5 7.5 9.515 12 12 12z"/>
              <path stroke-width="1.5" d="M4.5 21v-1.5C4.5 17.567 7.567 15 12 15s7.5 2.567 7.5 4.5V21"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ totalProspects }}</div>
          <div class="text-xs text-gray-500">prospects</div>
        </div>
      </div>

      <!-- Card: Prospects contactés -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Prospects contactés</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M3 7.5L12 13.5 21 7.5"/>
              <rect x="3" y="5.25" width="18" height="13.5" rx="2.25" stroke-width="1.5"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ prospectsContactes }}</div>
          <div class="text-xs text-gray-500">contactés</div>
        </div>
      </div>

      <!-- Card: Prospects en attente -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Prospects en attente</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M7.5 8.25h9M7.5 12h6M4.5 19.5l3.75-3.75h9.75A2.25 2.25 0 0 0 20.25 13.5V6.75A2.25 2.25 0 0 0 18 4.5H6A2.25 2.25 0 0 0 3.75 6.75v9"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-baseline gap-2">
          <div class="text-3xl font-semibold text-gray-900">{{ prospectsEnAttente }}</div>
          <div class="text-xs text-gray-500">en attente</div>
        </div>
      </div>

      <!-- Card: Prospects acceptés -->
      <div class="rounded-2xl bg-white shadow-sm border border-gray-100 p-5">
        <div class="flex items-center justify-between">
          <div class="text-sm font-medium text-gray-500">Prospects acceptés</div>
          <div class="p-2 rounded-xl bg-gray-50">
            <svg class="w-5 h-5 text-gray-600" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6-6 6 6"/>
            </svg>
          </div>
        </div>
        <div class="mt-3 flex items-center justify-between">
          <div class="flex items-baseline gap-2">
            <div class="text-3xl font-semibold text-gray-900">{{ prospectsAcceptees }}</div>
          </div>
          <span
            class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium"
            :class="prospectsGrowth >= 0 ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'"
          >
            <svg v-if="prospectsGrowth >= 0" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6-6 6 6"/>
            </svg>
            <svg v-else class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path stroke-width="1.5" d="M6 12l6 6 6-6"/>
            </svg>
            <span>{{ prospectsGrowth >= 0 ? 'En hausse' : 'En baisse' }}</span>
          </span>
        </div>
      </div>
    </div>

    <!-- Tableau des prospects -->
    <div class="overflow-x-auto bg-white shadow-sm rounded-2xl border border-gray-100">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nom</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Téléphone</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date contacté</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr v-for="prospect in prospects" :key="prospect.telephone">
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ prospect.nom }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{{ prospect.telephone }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{{ prospect.dateContact }}</td>
            <td class="px-6 py-4 whitespace-nowrap text-sm">
              <span
                class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                :class="statusClass(prospect.status)"
              >
                {{ prospect.status }}
              </span>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm flex gap-2">
              <button @click="voirProspect(prospect)" class="p-2 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 transition" title="Voir">
                <!-- Eye Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5s8.268 2.943 9.542 7c-1.274 4.057-5.065 7-9.542 7s-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
              <button @click="supprimerProspect(prospect)" class="p-2 bg-red-50 text-red-600 rounded hover:bg-red-100 transition" title="Supprimer">
                <!-- Trash Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m-6 0V5a2 2 0 012-2h2a2 2 0 012 2v2"/>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalProspects: 960,
      prospectsContactes: 300,
      prospectsEnAttente: 450,
      prospectsAcceptees: 210,
      prospectsGrowth: 15, // %
      prospects: [
        { nom: 'Salon A', telephone: '0612345678', dateContact: '2025-08-25', status: 'En attente' },
        { nom: 'Salon B', telephone: '0678901234', dateContact: '2025-08-24', status: 'Contacté' },
        { nom: 'Salon C', telephone: '0611122233', dateContact: '2025-08-23', status: 'Accepté' },
        { nom: 'Salon D', telephone: '0676543210', dateContact: '2025-08-22', status: 'Refusé' },
      ]
    }
  },
  methods: {
    statusClass(status) {
      switch(status) {
        case 'Accepté': return 'bg-green-100 text-green-800';
        case 'Refusé': return 'bg-red-100 text-red-800';
        case 'Contacté': return 'bg-blue-100 text-blue-800';
        case 'En attente': return 'bg-yellow-100 text-yellow-800';
        default: return 'bg-gray-100 text-gray-800';
      }
    },
    voirProspect(prospect) {
      console.log('Voir prospect', prospect);
    },
    supprimerProspect(prospect) {
      console.log('Supprimer prospect', prospect);
    }
  }
}
</script>
